import './Loading.css';

export default function Loading() {
  return (
    <div className="Loading">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="12"
        viewBox="0 0 64 12"
        className="Loading-logo"
      >
        <circle className="Loading-dot" cx="6" cy="6" r="6" />
        <circle className="Loading-dot" cx="32" cy="6" r="6" />
        <circle className="Loading-dot" cx="58" cy="6" r="6" />
      </svg>
    </div>
  );
}
